/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useLDCContext } from '../../contexts/LoanDefaultCodesContext';
import { Button } from '@mui/material';
import Styles from '../../css/LoanDefaultCodes.module.css';

import DefaultModal from '../modals/DefaultModal';

const ErrorsModal = () => {
  const { LDCStatus, LDCUIStatuses, LDCFunctions } = useLDCContext();
  const { errorLoading, errorSaving, errorEndpoint, loading, errorValidating } = LDCStatus;
  const { handleErrorsSeen } = LDCFunctions;
  const { errorsSeen, showReload } = LDCUIStatuses;

  const errors = () => {
    return (
      <div>
        {errorSaving !== '' && <div className={Styles.errorldc}>{'Error saving data. \n' + errorSaving}</div>}

        {errorLoading !== '' && <div className={Styles.errorldc}>{'Error loading data. \n' + errorLoading}</div>}

        {errorEndpoint !== '' && errorValidating === '' && <div className={Styles.errorendpoint}>{errorEndpoint}</div>}

        {errorValidating != '' && <div className={Styles.errorldc}>{errorValidating}</div>}
      </div>
    );
  };

  const showErrors =
    ((errorLoading !== '' || errorSaving !== '' || errorEndpoint !== '') && !errorsSeen && !loading) ||
    errorValidating != '';

  const showErrorsTitle = errorLoading !== '' || errorSaving !== '' || errorValidating !== '';

  return (
    showErrors && (
      <DefaultModal
        open={showErrors}
        title={<div className={Styles.modaltitle}>{showErrorsTitle ? 'Errors' : 'Information'}</div>}
        content={
          <div className={Styles.modalcontainer}>
            <div className={Styles.row}>{errors()}</div>
          </div>
        }
        footer={
          <div className={Styles.buttonrow}>
            <Button
              fullWidth
              variant='contained'
              onClick={() => {
                handleErrorsSeen();
              }}
              className={Styles.primbutton}
            >
              {showReload ? 'Reload' : 'I Understand'}
            </Button>
          </div>
        }
      ></DefaultModal>
    )
  );
};

export default ErrorsModal;
